import React, { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';
const ax  = axios.create({ baseURL: API, withCredentials: true });

export default function DomainCheckerSection() {
  const [input,   setInput]   = useState('');
  const [results, setResults] = useState(null);
  const [base,    setBase]    = useState('');
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');

  const check = async () => {
    if (!input.trim() || loading) return;
    setLoading(true);
    setError('');
    setResults(null);
    try {
      const { data } = await ax.post('/api/tools/check-domain', { domain: input.trim() });
      setBase(data.base);
      setResults(data.results);
    } catch {
      setError('Erreur lors de la vérification. Réessayez dans un moment.');
    }
    setLoading(false);
  };

  const Pill = ({ available }) => {
    if (available === true)  return <span style={{ display:'inline-flex', alignItems:'center', gap:5, background:'rgba(74,222,128,0.1)', border:'1px solid rgba(74,222,128,0.2)', borderRadius:99, padding:'3px 10px', fontSize:'0.67rem', fontWeight:700, color:'#4ade80', textTransform:'uppercase', letterSpacing:'0.06em' }}><span style={{ width:5, height:5, borderRadius:'50%', background:'#4ade80', display:'inline-block' }}/>Disponible</span>;
    if (available === false) return <span style={{ display:'inline-flex', alignItems:'center', gap:5, background:'rgba(248,113,113,0.08)', border:'1px solid rgba(248,113,113,0.15)', borderRadius:99, padding:'3px 10px', fontSize:'0.67rem', fontWeight:700, color:'#f87171', textTransform:'uppercase', letterSpacing:'0.06em' }}><span style={{ width:5, height:5, borderRadius:'50%', background:'#f87171', display:'inline-block' }}/>Pris</span>;
    return <span style={{ display:'inline-flex', alignItems:'center', gap:5, background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.06)', borderRadius:99, padding:'3px 10px', fontSize:'0.67rem', fontWeight:700, color:'#444', textTransform:'uppercase', letterSpacing:'0.06em' }}>Inconnu</span>;
  };

  return (
    <div style={{ animation:'fadeIn 0.3s ease' }}>
      <div style={{ marginBottom:32 }}>
        <div style={{ fontSize:'0.65rem', color:'#555', fontWeight:700, letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:6 }}>Outil gratuit</div>
        <h2 style={{ fontSize:'1.6rem', fontWeight:900, color:'#EAEAEA', letterSpacing:'-0.03em', marginBottom:4 }}>Vérificateur de domaine</h2>
        <p style={{ color:'#555', fontSize:'0.85rem' }}>Vérifiez la disponibilité sur .com · .ca · .net · .org · .io</p>
      </div>

      {/* SEARCH */}
      <div style={{ display:'flex', gap:10, marginBottom:28 }}>
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && check()}
          placeholder="monentreprise"
          style={{ flex:1, background:'#111', border:'1px solid rgba(255,255,255,0.1)', borderRadius:10, padding:'12px 16px', color:'#EAEAEA', fontSize:'0.9rem', outline:'none', fontFamily:'inherit' }}
        />
        <button
          onClick={check}
          disabled={loading || !input.trim()}
          style={{ background:'#C8FF00', color:'#000', border:'none', padding:'12px 26px', borderRadius:10, fontWeight:800, fontSize:'0.88rem', cursor: loading || !input.trim() ? 'not-allowed' : 'pointer', opacity: loading || !input.trim() ? 0.5 : 1, whiteSpace:'nowrap' }}
        >
          {loading ? 'Vérification…' : 'Vérifier'}
        </button>
      </div>

      {error && <div style={{ color:'#f87171', fontSize:'0.84rem', marginBottom:16, padding:'10px 14px', background:'rgba(248,113,113,0.06)', borderRadius:8, border:'1px solid rgba(248,113,113,0.12)' }}>{error}</div>}

      {/* LOADING */}
      {loading && (
        <div style={{ display:'flex', alignItems:'center', gap:10, color:'#444', fontSize:'0.84rem', padding:'20px 0' }}>
          <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
          <div style={{ width:16, height:16, border:'2px solid rgba(200,255,0,0.15)', borderTop:'2px solid #C8FF00', borderRadius:'50%', animation:'spin 0.7s linear infinite' }}/>
          Consultation des registres de domaines…
        </div>
      )}

      {/* RESULTS */}
      {results && !loading && (
        <div>
          <div style={{ fontSize:'0.65rem', color:'#555', fontWeight:700, letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:14 }}>Résultats pour « {base} »</div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(200px, 1fr))', gap:10 }}>
            {results.map(r => (
              <div key={r.domain} style={{
                background:'#111',
                border:`1px solid ${r.available === true ? 'rgba(74,222,128,0.25)' : r.available === false ? 'rgba(255,255,255,0.05)' : 'rgba(255,255,255,0.05)'}`,
                borderRadius:12, padding:'18px 18px',
              }}>
                <div style={{ fontWeight:900, color:'#EAEAEA', fontSize:'1rem', marginBottom:10, letterSpacing:'-0.02em' }}>{r.domain}</div>
                <Pill available={r.available} />
                {r.available === false && r.expiry && (
                  <div style={{ marginTop:8, color:'#333', fontSize:'0.72rem' }}>
                    Expire : {new Date(r.expiry).toLocaleDateString('fr-CA')}
                  </div>
                )}
                {r.available === true && (
                  <a
                    href={`https://www.namecheap.com/domains/registration/results/?domain=${r.domain}`}
                    target="_blank" rel="noreferrer"
                    style={{ display:'block', marginTop:12, textAlign:'center', background:'rgba(74,222,128,0.08)', border:'1px solid rgba(74,222,128,0.18)', color:'#4ade80', padding:'7px 10px', borderRadius:8, fontSize:'0.76rem', fontWeight:700, textDecoration:'none' }}
                  >
                    Enregistrer →
                  </a>
                )}
              </div>
            ))}
          </div>
          <div style={{ marginTop:16, fontSize:'0.72rem', color:'#2a2a2a' }}>
            Données RDAP en temps réel · Namecheap pour l'enregistrement
          </div>
        </div>
      )}
    </div>
  );
}
